// src/components/team/constants.ts
// Shared constants for team planner roles.

export type Role = "Top" | "Jungle" | "Mid" | "Bot" | "Support";

export const ROLES: Role[] = ["Top", "Jungle", "Mid", "Bot", "Support"];
